import { faBarChart, faBolt } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';

import { profileColours } from '../../assets/colours';
import { MenuOptionButton } from '../components/menuOptionButton/MenuOptionButton';

type ProfileStatsLeftMenuProps = {
  activeSubMenu: { id: number };
  changeSubMenu: (index: number) => void;
};

export function ProfileStatsLeftMenu({ activeSubMenu, changeSubMenu }: ProfileStatsLeftMenuProps) {
  const { t } = useTranslation();

  return (
    <>
      <MenuOptionButton
        id={61}
        icon={faBolt}
        text={t('S043')}
        onClick={() => changeSubMenu(0)}
        isActive={activeSubMenu.id === 61}
        color={profileColours.blue}
      />
      <MenuOptionButton
        id={62}
        icon={faBarChart}
        text={t('S047')}
        onClick={() => changeSubMenu(1)}
        isActive={activeSubMenu.id === 62}
        color={profileColours.yellow}
      />
    </>
  );
}
